import React  from "react";
import PayslipTable from "./components/PayslipTable";
import { connect } from "react-redux";


const Payslips = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<PayslipTable />
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Payslips);